import React, { FC } from 'react';
import LazyPageLoader from './LazyPageLoader';
import paths from './paths';
import { GuardFnResult } from './routeGuards';
import Home from '@/pages/home';

type pathKeys = keyof typeof paths;
type PathValues = typeof paths[pathKeys];

type Route = {
  path: PathValues;
  component: FC;
  guards?: { (): GuardFnResult }[];
};

const routeConfig: Route[] = [
  {
    path: paths.home,
    component: Home,
  },
  {
    path: paths.paymentReceipt,
    component: () => (
      <LazyPageLoader page={() => import('../pages/payement-receipt')} />
    ),
  },
  {
    path: paths.tipResult,
    component: () => (
      <LazyPageLoader page={() => import('../pages/tip-result')} />
    ),
  },
  {
    path: paths.proInRide,
    component: () => (
      <LazyPageLoader page={() => import('../pages/pro-in-ride')} />
    ),
  },
];

export default routeConfig;
